import React from "react";
import PropTypes from "prop-types";

const Loader = ({ label = "Loading", className = "", size = 16 }) => (
  <div
    className={`flex items-center gap-3 text-[#003DA5] ${className}`.trim()}
    role="status"
    aria-live="polite"
  >
    <span
      className="inline-block animate-spin rounded-full border-2 border-current border-t-transparent"
      style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 8)) }}
    />
    {label ? <span className="text-sm text-gray-700">{label}</span> : null}
  </div>
);

Loader.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
};

export default Loader;
